import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    lang_code: null,
    common_content: null,
    user_data: null,
    user_token: null,
    common_data: {},
    payment_card: {},
    promocode_data: {},
    setting_data: {},
    device_id: null,
};

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        languageCode: (state, action) => {
            state.lang_code = action.payload;
        },
        commonContent: (state, action) => {
            state.common_content = action.payload;
        },
        userData: (state, action) => {
            state.user_data = action.payload;
        },
        userToken: (state, action) => {
            state.user_token = action.payload;
        },
        commonData: (state, action) => {
            state.common_data = action.payload;
        },
        paymentCardData: (state, action) => {
            state.payment_card = action.payload;
        },
        promoCodeData: (state, action) => {
            state.promocode_data = action.payload;
        },
        settingData: (state, action) => {
            state.setting_data = action.payload;
        },
        deviceIdData: (state, action) => {
            state.device_id = action.payload;
        },
        logoutAction: () => {
            return initialState;
        },
    },
});

export const { languageCode, commonContent, userData, userToken, commonData, paymentCardData, promoCodeData, settingData, deviceIdData, logoutAction } = commonSlice.actions;
export default commonSlice.reducer;
